export default __webpack_public_path__ + "static/media/Mulish-Light.5957f99d.ttf";